import React from 'react'
import { Slider, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

interface IRequiredExperienceSliderProps {
  skill: { requiredYears: number, name: string, id: string }
  onChange: (value: number) => void
  style?: React.CSSProperties
}

const SLIDER_MARKS = [
  { value: 0 },
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 },
  { value: 10 },
]

const useStyles = makeStyles()(theme => ({
  container: {
    marginBottom: theme.spacing(3),
  },
  label: {
    width: 240,
    maxWidth: '100%',
  },
  slider: {
    padding: 1,
  },
}))

const RequiredExperienceSlider = ({ skill, style, onChange }: IRequiredExperienceSliderProps) => {
  const { classes } = useStyles()
  const [transientValue, setTransientValue] = React.useState(skill?.requiredYears || 0)

  // sync upstream changes into state
  React.useEffect(() => setTransientValue(skill?.requiredYears || 0), [skill?.requiredYears])

  if (!skill) return null

  const transientValueRounded = Math.round(transientValue || 0)

  return (
    <div data-cy={`experience-slider-${skill.name}`} className={classes.container} style={style}>
      <Typography variant="subtitle2" className={classes.label}>
        {!transientValueRounded && <React.Fragment>Any years of <strong>{skill.name}</strong> experience</React.Fragment>}
        {transientValueRounded === 1 && <React.Fragment><strong>1+</strong> year of <strong>{skill.name}</strong> experience</React.Fragment>}
        {transientValueRounded > 1 && <React.Fragment><strong>{transientValueRounded}+</strong> years of <strong>{skill.name}</strong> experience</React.Fragment>}
      </Typography>

      <div className={classes.slider}>
        <Slider
          min={0}
          max={10}
          step={0.01}
          value={transientValue}
          marks={SLIDER_MARKS}
          onChange={(_e, v) => setTransientValue(v as number)}
          onChangeCommitted={() => {
            const newValue = Math.round(transientValue)
            setTransientValue(newValue)
            onChange(newValue)
          }}
        />
      </div>
    </div>
  )
}

export default React.memo(RequiredExperienceSlider)
